
















import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectTemplateTaskGroup from "../models/project-template-task-group";
import SelectOption from "@/common/ui/presenters/select-option";

@Component({})
export default class PlanTaskGroupEditModal extends Vue {
  @Prop({ default: () => [] }) options!: SelectOption[];

  public show(group: ProjectTemplateTaskGroup) {
    this.group = group;
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  okTitle = "保存";
  cancelTitle = "削除";
  cancelVariant = "danger";

  group: ProjectTemplateTaskGroup = {
    id: 0,
    tasks: [],
    taskTypeId: 0,
    projectTemplateId: 0
  };

  submit() {
    this.$emit("submit", this.group);
  }

  cancel() {
    this.$emit("delete", this.group);
  }
}
